import axios from 'axios';
import {withAuth} from "../utils/authTokens";

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_KB_URL}`
});

// token on every request, refreshed before it expires and on a 401 (see withAuth)
withAuth(instance);

export const setKbRagBaseURL = (url) => {
    instance.defaults.baseURL = url;
};


export default instance;
